import { SurveyForm } from 'pages/Survey';
import * as base from './lib/baseActions';

const createSurveyReponse = async (survey: SurveyForm): Promise<void> => {
  await base.post(`survey`, {...survey});
}

export {
  createSurveyReponse,
};